import React, { useEffect, useState } from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useHomeContext from 'Context/HomeContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import fr from 'facet-rest';
import SelectScenarioButtonPicker from 'Components/ComponentLibrary/Organisms/SelectScenarioButton';
import { useSnackbarContext } from 'Context/SnackbarContext';
import BackButtonPicker from './BackButtonPicker';

const useStyles = buildUseStyles('SelectScenario', theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: theme.spacing(2),
    gap: `${theme.spacing(2)}px`,
    maxWidth: theme.dimensions.md,
    margin: '0 auto', // Center the buttons
  },
}));

const SelectScenario = () => {
  const {
    pageContentResource,
    setPageContentCollection,
    isPageContentLoading,
    loadPageContentLink,
  } = usePageContentContext();
  const { refreshHomeResource } = useHomeContext();
  const { displayErrorMessage } = useSnackbarContext();
  const classes = useStyles();
  const { logStandardizedEvent, logEventFailureWithError } = useEventTrackingLogEvent();

  const [loadingAction, setLoadingAction] = useState('');
  useEffect(() => {
    if (isPageContentLoading === false) {
      setLoadingAction('');
    }
  }, [isPageContentLoading]);

  const selectScenario = async (resource) => {
    logStandardizedEvent(categories.clientWhatIf, eventTypes.clickButton, 'Clicked Select Scenario from Scenario Details page');
    const updatedColl = await resource.submit();
    refreshHomeResource();
    await setPageContentCollection(updatedColl);
  };

  const handleScenarioSelectionClick = async (scenarioInsightResource) => {
    logStandardizedEvent(categories.clientWhatIf, eventTypes.clickButton, 'Clicked Select Scenario from Scenario Details page');
    setLoadingAction(`selectScenario-${scenarioInsightResource.id()}`);
    try {
      await loadPageContentLink(scenarioInsightResource.relationship(fr.relationships.selectScenario.name).link('related'));
    } catch (err) {
      logEventFailureWithError('Scenario Details - Failed to load select scenario page from Scenario Details oage', err);
      displayErrorMessage(err, err.errors);
    }
  };

  return (
    <div className={classes.root}>
      <BackButtonPicker />
      <SelectScenarioButtonPicker
        scenarioInsightResource={pageContentResource}
        buttonLabel={'Select Scenario'}
        onConfirm={pageContentResource.withRelationship(fr.relationships.selectScenario.name,
          () => () => handleScenarioSelectionClick(pageContentResource),
          () => () => selectScenario(pageContentResource))}
        loading={loadingAction === `selectScenario-${pageContentResource.id()}`}
        disabled={isPageContentLoading}
      />
    </div>
  );
};

export default SelectScenario;
